import type { QuestionModule } from "../contracts";
import {
  gridThisOrThatRatingCore,
  type GridThisOrThatRatingRaw,
  type GridThisOrThatRatingDefinition,
  type GridThisOrThatRatingDraft,
  type GridThisOrThatRatingEvent,
  type GridThisOrThatRatingResponse,
} from "./core";
import {
  GridThisOrThatRatingButtonsView,
  GridThisOrThatRatingSliderView,
} from "./views";

export const gridThisOrThatRatingModule: QuestionModule<
  GridThisOrThatRatingRaw,
  GridThisOrThatRatingDefinition,
  GridThisOrThatRatingDraft,
  GridThisOrThatRatingEvent,
  GridThisOrThatRatingResponse
> = {
  type: "grid_this_or_that_rating",
  galleryFeatures: [
    "visual-groups",
    "baseline",
    "rows",
    "labels",
    "images",
    "restored",
    "dont-know",
    "unanswered",
    "non-one-based",
  ],
  core: gridThisOrThatRatingCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    buttons: {
      id: "buttons",
      label: "Buttons",
      component: GridThisOrThatRatingButtonsView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
    slider: {
      id: "slider",
      label: "Slider",
      component: GridThisOrThatRatingSliderView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "slider" },
  resolveDisplay: (raw) => ({
    view: raw.style === "button" ? "buttons" : "slider",
  }),
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
